// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"3064":"chunk-common","4998":"chunk-vendors","8099":"chunk-mapbox-gl"}[chunkId] || chunkId) + ".js";
};